import CN from "classnames";
import React, { FC, useState, useEffect } from "react";
import ImageUpload, { Image } from "./plugins/ImageUpload";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button } from "../../components/Button";
import { useSelector, UseSelector } from "react-redux";
import store from "../../store/store";
import { Oval } from "react-loader-spinner";
import { addbanners } from "./reducer/bannerSlice";
import EditBanner from "./components/EditBanner";

interface FormValues {
  title: string;
  offer: string;
  priority: string;
  file?: File | null;
}
export const AddBanners: React.FC<any> = () => {
  const { mainBannerData = { mainBanner: [] }, isLoading } = useSelector(
    (state: any) => state.rootReducer.banner
  );
  const { fullResponse } = useSelector(
    (state: any) => state.rootReducer.offers
  );
  console.log("mainBannerData", fullResponse);
  const validationSchema = Yup.object({
    title: Yup.string(),
    offer: Yup.string(),
    priority: Yup.string(),
    file: Yup.mixed().required("Image is required"),
  });

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    values,
    errors,
    touched,
  } = useFormik<FormValues>({
    initialValues: {
      title: "",
      offer: "",
      priority: "",
      file: null,
    },
    validationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      Object.entries(values).forEach(([key, value]) => {
        if (key === "file") {
          if (value) {
            formData.append("file", value as File);
          }
        } else if (Array.isArray(value)) {
          value.forEach((val) => formData.append(`${key}[]`, val));
        } else {
          formData.append(key, value as string);
        }
      });
      // console.log("formData", formData);
      // addProductContext?.addNewProduct(formData);
      store.dispatch(addbanners(formData));
    },
  });
  const handleImageUpload = (image: File | Image | null) => {
    setFieldValue("file", image);
  };

  return (
    <div className="block py-6 my-4 md:mx-8 mx-4 ">
      <form onSubmit={handleSubmit}>
        <div className="lg:grid grid-cols-2 flex flex-col gap-6">
          <div className="col-span-2">
            <label className="block text-base font-semibold mb-2">
              Banner <span className="text-red-500">*</span>
            </label>
            <ImageUpload onUpload={handleImageUpload} />
            {errors.file && touched.file && (
              <p className="text-red-500 text-sm my-2">{errors.file}</p>
            )}
          </div>
          <div className="col-span-1">
            <label className="block text-base font-semibold mb-2">Title</label>
            <input
              type="text"
              name="title"
              value={values.title}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Title"
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.title && touched.title
                  ? "border-red-500"
                  : "border-primary1"
              )}
            />
            {errors.title && touched.title && (
              <p className="text-red-500 text-sm my-2">{errors.title}</p>
            )}
          </div>
          <div className="col-span-1">
            <div className="flex flex-col gap-1 mb-2">
              <label className="block text-base font-semibold">
                Banner Type <span className="text-red-500">*</span>
              </label>
            </div>
            <select
              name="priority"
              value={values.priority}
              onChange={handleChange}
              onBlur={handleBlur}
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.priority && touched.priority
                  ? "border-red-500"
                  : "border-primary1"
              )}
            >
              <option value="" disabled hidden>
                Select Banners
              </option>
              <option value={1}>Main Banner</option>
              <option value={2}>Middle Banner</option>
              <option value={3}>Bottom Banner</option>
            </select>
            {errors.priority && touched.priority && (
              <p className="text-red-500 text-sm my-2">{errors.priority}</p>
            )}
          </div>

          <div className="col-span-1">
            <div className="flex flex-col gap-1 mb-2">
              <label className="block text-base font-semibold">Offers</label>
            </div>
            <select
              name="offer"
              value={values.offer}
              onChange={handleChange}
              onBlur={handleBlur}
              className={CN(
                "block w-full p-3 border rounded-md",
                errors.offer && touched.offer
                  ? "border-red-500"
                  : "border-primary1"
              )}
            >
               <option value="" disabled hidden>
                Select Discount
              </option>
              {fullResponse?.map((item: any, index: number) => (
                <option
                  key={index}
                  value={item._id}
                >{`${item?.name} - ${item?.discountPrecentage}%`}</option>
              ))}
            </select>
            {errors.offer && touched.offer && (
              <p className="text-red-500 text-sm my-2">{errors.offer}</p>
            )}
          </div>
          <div className="col-span-2 flex justify-start gap-5">
            {/* <Button onClick={() => navigate("/brands")} apparence="gray">
              Cancel
            </Button> */}

            <Button
              isLoading={isLoading.addBanners}
              view="default"
              type="submit"
            >
              <div className="flex gap-1">
                {isLoading.addBanners && (
                  <Oval
                    height={18}
                    width={18}
                    color="#ffff"
                    wrapperStyle={{}}
                    wrapperClass="max-sm:mt-[3.5px] mt-[5.2px] max-lg:mt-[5.2px]"
                    visible={true}
                    ariaLabel="oval-loading"
                    secondaryColor="gray-primary"
                    strokeWidth={6}
                    strokeWidthSecondary={6}
                  />
                )}
                <div className="font-normal text-base">Save</div>
              </div>
            </Button>
          </div>
        </div>
      </form>
      <div className="flex flex-col my-20 px-10 w-full">
        <h2 className="text-primary text-2xl font-semibold mt-2 text-center">
          Main Banner
        </h2>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 my-4 ">
          {Array.isArray(mainBannerData?.mainBanner) &&
          mainBannerData.mainBanner.length > 0 ? (
            mainBannerData.mainBanner
              .filter((item: any) => item?.priority === 1)
              .map((item: any, index: number) => (
                <EditBanner key={index} item={item} />
              ))
          ) : (
            <p>No banners available</p>
          )}
        </div>
      </div>
      <div className="flex flex-col my-20 px-10 w-full">
        <h2 className="text-primary text-2xl font-semibold mt-2 text-center">
          Middle Banner
        </h2>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 my-4 ">
          {Array.isArray(mainBannerData?.mainBanner) &&
          mainBannerData.mainBanner.length > 0 ? (
            mainBannerData.mainBanner
              .filter((item: any) => item?.priority === 2)
              .map((item: any, index: number) => (
                <EditBanner key={index} item={item} />
              ))
          ) : (
            <p>No banners available</p>
          )}
        </div>
      </div>
      <div className="flex flex-col my-20 px-10 w-full">
        <h2 className="text-primary text-2xl font-semibold mt-2 text-center">
          Bottom Banner
        </h2>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 my-4 ">
          {Array.isArray(mainBannerData?.mainBanner) &&
          mainBannerData.mainBanner.length > 0 ? (
            mainBannerData.mainBanner
              .filter((item: any) => item?.priority === 3)
              .map((item: any, index: number) => (
                <EditBanner key={index} item={item} />
              ))
          ) : (
            <p>No banners available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddBanners;
